import weaviate from "weaviate-client";
// import { checkTokens } from "../../helperFunctions";
import { getWeaviateScheme, getWeaviateHost } from "../../helperFunctions";

export const headerObj = () => {
  const token = JSON.parse(localStorage.getItem("access_token"));
  const isWeaviateAuthenticated = JSON.parse(
    localStorage.getItem("isWeaviateAuthenticated")
  );

  if (isWeaviateAuthenticated === true && token !== "") {
    return {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
      origin: window.origin,
    };
  } else {
    return {
      "Content-Type": "application/json",
      origin: window.origin,
    };
  }
};

const setTheme = (state) => {
  let schemaRoot = document.documentElement;

  if (state.theme === "light") {
    schemaRoot.style.setProperty("--schemaModule-json-key", "#00152b");
    schemaRoot.style.setProperty("--schemaModule-json-string", "#b04802");
    schemaRoot.style.setProperty("--schemaModule-json-background", "#fff");
    schemaRoot.style.setProperty("--schemaModule-json-color", "#95025c");
    schemaRoot.style.setProperty("--schemaModule-json-value", "#304a6c");
    schemaRoot.style.setProperty("--schemaModule-json-boolean", "#fa0171");
    schemaRoot.style.setProperty("--schemaModule-json-error", "#ff1101");
  } else if (state.theme === "dark") {
    schemaRoot.style.setProperty("--schemaModule-json-key", "#45bfb0");
    schemaRoot.style.setProperty("--schemaModule-json-string", "#e2e9ff");
    schemaRoot.style.setProperty("--schemaModule-json-background", "#122742");
    schemaRoot.style.setProperty("--schemaModule-json-color", "#f17c3b");
    schemaRoot.style.setProperty("--schemaModule-json-value", "#009c00");
    schemaRoot.style.setProperty("--schemaModule-json-boolean", "#95025c");
    schemaRoot.style.setProperty("--schemaModule-json-error", "#ff1101");
  }
};

export const getSchema = (state, setState, setSchema, history) => {
  setTheme(state);

  if (state.connectToWeaviateURI === "") {
    setState({ ...state, isWeaviateURIDisconnected: true });
    history.push("/console/Schema/weaviate-not-connected");
  } else {
    const client = weaviate.client({
      scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
      host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
      headers: headerObj(),
    });

    client.schema
      .getter()
      .do()
      .then((res) => {
        setState({ ...state, isWeaviateURIDisconnected: false });
        setSchema(res);
      })
      .catch((err) => {
        console.error(err);
        setState({ ...state, isWeaviateURIDisconnected: true });
      });
  }
};

export const pushToComingSoonPage = (history) => {
  history.push("/console/Schema/file-upload/coming-soon");
};

export const submitAddClassForm = (
  e,
  schemaState,
  state,
  setState,
  history
) => {
  e.preventDefault();

  const token = JSON.parse(localStorage.getItem("access_token"));

  const getClient = () => {
    if (token === "") {
      const client = weaviate.client({
        scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
        host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
        headers: {
          origin: window.origin,
        },
      });

      return client;
    } else if (token) {
      const client = weaviate.client({
        scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
        host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
        headers: {
          authorization: `Bearer ${token}`,
          origin: window.origin,
        },
      });

      return client;
    } else {
      const client = weaviate.client({
        scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
        host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
        headers: {
          origin: window.origin,
        },
      });

      return client;
    }
  };

  const client = getClient();

  const properties = schemaState.properties.reduce((acc, cur) => {
    acc.push({
      name: cur.name,
      description: cur.description,
      dataType: cur.dataType,
      vectorizePropertyName: cur.vectorizePropertyName,
      index: cur.index,
    });

    return acc;
  }, []);

  const getClassObj = () => {
    if (schemaState.vectorizeClassName) {
      return {
        class: schemaState.class,
        description: schemaState.description,
        vectorizeClassName: schemaState.vectorizeClassName,
        properties: properties,
      };
    } else {
      return {
        class: schemaState.class,
        description: schemaState.description,
        properties: properties,
      };
    }
  };

  client.schema
    .classCreator()
    .withClass(getClassObj())
    .do()
    .then((res) => {
      console.log(res);
      setState({
        ...state,
        schema: { ...state.schema, schemaUpdate: !state.schema.schemaUpdate },
      });
      history.push("/console/Schema/view-schema");
    })
    .catch((err) => {
      console.error(err);
    });
};
